//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    currentPendant: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  methods: {
    sortImages(images) {
      const sorted = Object.keys(images).sort().reduce(
        (obj, key) => {
          obj[key] = images[key];
          return obj;
        },
        {}
      );
      const arr = [];
      for (const i in sorted) {
        arr.push(sorted[i])
      }
      return arr
    },
    addAPendant(index) {
      let arr = this.$route.query.configId.split(',');
      let pendantUrlIndex = arr.findIndex(item => item === "");
      if (this.currentPendant.urlIndex || this.currentPendant.urlIndex === 0) {
        pendantUrlIndex = this.currentPendant.urlIndex + 1;
      }
      arr[pendantUrlIndex] = this.info.connected_products[index].default_config.configuration_id;
      if (this.info.connected_products[index].connected_configs && this.info.connected_products[index].connected_configs.bail && this.info.connected_products[index].connected_configs.bail.length) {
        arr[pendantUrlIndex] = `${arr[pendantUrlIndex]}|${this.info.connected_products[index].connected_configs.bail[0].configuration_id}`
      }
      const query = {...this.$route.query, configId: arr.join(',')};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query});
      }
      // this.$nextTick(() => {
      //   this.$parent.$emit('changeStage', 'Pendants');
      //   this.$parent.$emit('editStone', pendantUrlIndex - 1);
      // })
    },
  },
}
